/* Mckwurst Designs product page behavior. No dependencies.
   Every enhancement starts hidden or inert in the markup, so a page without JavaScript still
   posts the form normally: gallery photos stack, the stepper is a plain number field, and the
   form posts to /cart/add. */
(function () {
  'use strict';

  /* The section markup carries this script tag, so the theme editor can run it twice. */
  if (window.__mckProduct) return;
  window.__mckProduct = true;

  var ready = new WeakSet();

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setText(el, text) {
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('has-text', Boolean(text));
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery) return { showMedia: function () {} };
    var slides = all(gallery, '[data-slide]');
    var thumbs = all(gallery, '[data-thumb]');

    function show(index) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        if (i !== index) {
          var clip = slide.querySelector('video');
          if (clip && !clip.paused) clip.pause();
        }
      });
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
    }

    if (slides.length > 1) {
      gallery.classList.add('is-enhanced');
      thumbs.forEach(function (thumb, i) {
        thumb.hidden = false;
        thumb.addEventListener('click', function () {
          gallery.classList.add('is-switched');
          show(i);
        });
      });
    }

    return {
      showMedia: function (mediaId) {
        if (mediaId == null || slides.length < 2) return;
        for (var i = 0; i < slides.length; i += 1) {
          if (Number(slides[i].getAttribute('data-media-id')) === Number(mediaId)) {
            gallery.classList.add('is-switched');
            show(i);
            return;
          }
        }
      }
    };
  }

  /* Writes to the pre-existing role=status region so assistive technology announces the change. */
  function announcer(root) {
    var region = root.querySelector('[data-variant-status]');
    return function (message) {
      if (!region) return;
      region.textContent = '';
      window.setTimeout(function () { region.textContent = message || ''; }, 50);
    };
  }

  /* Each fieldset in [data-option-group] holds the radios for one product option. */
  function initVariants(root, form, data, gallery, buy, announce) {
    var region = root.querySelector('[data-variant-status]');
    var personalize = root.querySelector('[data-personalize]');
    var unavailableNote = region ? region.getAttribute('data-msg-option-unavailable') : '';
    var groups = all(root, '[data-option-group]');
    var idInput = form.querySelector('[data-variant-id]');
    var current = null;

    function selected() {
      return groups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function find(options) {
      for (var i = 0; i < data.variants.length; i += 1) {
        var variant = data.variants[i];
        var match = variant.options.every(function (value, index) { return value === options[index]; });
        if (match) return variant;
      }
      return null;
    }

    function markAvailability(options) {
      groups.forEach(function (group, groupIndex) {
        all(group, 'input').forEach(function (input) {
          var trial = options.slice();
          trial[groupIndex] = input.value;
          var variant = find(trial);
          var label = group.querySelector('label[for="' + input.id + '"]');
          var unavailable = !variant || !variant.available;
          if (label) {
            label.classList.toggle('is-unavailable', unavailable);
            var note = label.querySelector('[data-unavailable-note]');
            if (unavailable && unavailableNote && !note) {
              note = document.createElement('span');
              note.className = 'visually-hidden';
              note.setAttribute('data-unavailable-note', '');
              note.textContent = ' (' + unavailableNote + ')';
              label.appendChild(note);
            } else if (!unavailable && note) {
              note.remove();
            }
          }
        });
        var checked = group.querySelector('input:checked');
        var name = group.querySelector('[data-selected-name]');
        if (name) name.textContent = checked ? checked.value : '';
      });
    }

    function syncPersonalize(variant) {
      if (personalize) personalize.hidden = !(variant && variant.available);
    }

    function describe(variant) {
      if (!region) return '';
      if (!variant) return region.getAttribute('data-msg-unavailable');
      if (!variant.available) return region.getAttribute('data-msg-sold-out');
      return region.getAttribute('data-msg-price').replace('__PRICE__', variant.price_text) + ' ' +
        region.getAttribute('data-msg-in-stock');
    }

    function apply(variant, options) {
      current = variant;
      markAvailability(options);
      syncPersonalize(variant);
      announce(describe(variant));
      if (variant) {
        idInput.value = variant.id;
        all(root, '[data-price]').forEach(function (el) { el.innerHTML = variant.price_html; });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(null, '', url.toString());
        gallery.showMedia(variant.media_id);
      }
      buy.setVariant(variant);
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function () {
        var options = selected();
        apply(find(options), options);
      });
    });

    var initial = selected();
    var initialVariant = groups.length ? find(initial) : data.variants.filter(function (v) {
      return String(v.id) === idInput.value;
    })[0] || null;
    current = initialVariant;
    if (groups.length) markAvailability(initial);
    syncPersonalize(initialVariant);
    buy.setVariant(initialVariant);

    return { current: function () { return current; } };
  }

  /* Quantity field, bulk table highlight, and the add button's state. */
  function initBuy(root, announce) {
    var buyRoot = root.querySelector('[data-buy]');
    var input = root.querySelector('[data-qty-input]');
    var button = root.querySelector('[data-add-button]');
    var qtyError = root.querySelector('[data-qty-error]');
    var steps = all(root, '[data-qty-step]');
    var rows = all(root, '[data-bulk-row]');
    var min = input ? Number(input.getAttribute('min')) || 1 : 1;
    var max = input && input.getAttribute('max') ? Number(input.getAttribute('max')) : Infinity;

    function highlight() {
      if (!rows.length || !input) return;
      var qty = Number(input.value);
      rows.forEach(function (row) {
        var low = Number(row.getAttribute('data-min'));
        var highText = row.getAttribute('data-max');
        var high = highText === '' ? Infinity : Number(highText);
        var on = qty >= low && qty <= high;
        row.classList.toggle('is-active', on);
        if (on) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
    }

    function stepState() {
      var qty = Number(input.value);
      steps.forEach(function (step) {
        var down = Number(step.getAttribute('data-qty-step')) < 0;
        var blocked = down ? qty <= min : qty >= max;
        step.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      });
    }

    function showQtyError(message) {
      setText(qtyError, message);
      if (qtyError) qtyError.hidden = !message;
      if (input) {
        if (message) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }
    }

    /* Clamp into [min, max]. Returns an error message when the typed value was out of range. */
    function clamp() {
      var qty = parseInt(input.value, 10);
      var message = '';
      if (isNaN(qty) || qty < min) {
        message = qtyError ? qtyError.getAttribute('data-min-message').replace('__MIN__', min) : '';
        qty = min;
      } else if (qty > max) {
        message = qtyError ? qtyError.getAttribute('data-max-message').replace('__MAX__', max) : '';
        qty = max;
      }
      input.value = qty;
      showQtyError(message);
      if (message) announce(message);
      stepState();
      highlight();
      return message;
    }

    if (input) {
      steps.forEach(function (step) {
        step.hidden = false;
        step.addEventListener('click', function () {
          if (step.getAttribute('aria-disabled') === 'true') return;
          var qty = parseInt(input.value, 10) || min;
          input.value = qty + Number(step.getAttribute('data-qty-step'));
          clamp();
        });
      });
      input.addEventListener('input', function () {
        highlight();
        showQtyError('');
        stepState();
      });
      input.addEventListener('change', clamp);
      stepState();
      highlight();
    }

    function setVariant(variant) {
      if (!button) return;
      var label = button.getAttribute('data-label-add');
      var disabled = false;
      if (!variant) {
        label = button.getAttribute('data-label-unavailable');
        disabled = true;
      } else if (!variant.available) {
        label = button.getAttribute('data-label-sold-out');
        disabled = true;
      }
      button.disabled = disabled;
      button.textContent = label;
      if (input) {
        var limit = variant && variant.stock_limit > 0 ? variant.stock_limit : 0;
        max = limit || Infinity;
        if (limit) input.setAttribute('max', limit);
        else input.removeAttribute('max');
        clamp();
      }
    }

    return {
      root: buyRoot,
      input: input,
      button: button,
      clamp: clamp,
      setVariant: setVariant
    };
  }

  /* Personalization choice (Monogram or Phrase, or Icon set). The checked radio opens its panel. Every other
     panel is hidden and its inputs are disabled, so they neither validate nor post. */
  function initChoice(root, wrapper) {
    var group = root.querySelector('[data-choice]');
    if (!group || !wrapper) return null;
    var panels = all(wrapper, '[data-choice-panel]');
    var listeners = [];

    function sync() {
      var checked = group.querySelector('input:checked');
      var open = checked ? checked.getAttribute('data-choice-for') : '';
      panels.forEach(function (panel) {
        var isOpen = panel.getAttribute('data-choice-panel') === open;
        panel.hidden = !isOpen;
        all(panel, 'input, select, textarea').forEach(function (input) { input.disabled = !isOpen; });
      });
      listeners.forEach(function (listener) { listener(); });
    }

    group.addEventListener('change', sync);
    sync();
    wrapper.setAttribute('data-choice-ready', '');
    return { onSwitch: function (listener) { listeners.push(listener); } };
  }

  /* A radio fieldset or a checkbox group (multi, exactly data-count picks) is a group. A text input wrapper is not. */
  function isGroup(field) {
    var kind = field.getAttribute('data-opt-field');
    return kind === 'radio' || kind === 'multi';
  }

  /* Personalization fields. A field is a radio fieldset or a text input wrapper marked
     data-opt-field. A product that allows both a monogram and a name needs one complete
     group, not both (data-pair-mode="either" on the wrapper). */
  function initFields(root) {
    var wrapper = root.querySelector('[data-personalize]');
    var fields = all(root, '[data-opt-field]');
    var pairMode = Boolean(wrapper && wrapper.getAttribute('data-pair-mode') === 'either');
    var choice = initChoice(root, wrapper);

    /* A field inside a closed choice panel is not part of the order. */
    function active(field) {
      var panel = field.closest('[data-choice-panel]');
      return !panel || !panel.hidden;
    }

    function control(field) {
      return isGroup(field)
        ? field.querySelector('input:checked') || field.querySelector('input')
        : field.querySelector('input');
    }

    function value(field) {
      if (field.getAttribute('data-opt-field') === 'multi') {
        /* Complete only with exactly data-count picks. */
        var picked = field.querySelectorAll('input[data-multi-input]:checked').length;
        return picked === Number(field.getAttribute('data-count')) ? String(picked) : '';
      }
      if (field.getAttribute('data-opt-field') === 'radio') {
        var checked = field.querySelector('input:checked');
        return checked ? checked.value : '';
      }
      return field.querySelector('input').value.trim();
    }

    function describe(field, withError) {
      var ids = [];
      var hint = field.getAttribute('data-hint-id');
      if (hint) ids.push(hint);
      if (withError) ids.push(field.getAttribute('data-error-id'));
      var target = isGroup(field) ? field : field.querySelector('input');
      if (ids.length) target.setAttribute('aria-describedby', ids.join(' '));
      else target.removeAttribute('aria-describedby');
      // A screen reader announces the focused radio, not the group, so the error id also goes on each radio.
      if (target === field) {
        var errorId = field.getAttribute('data-error-id');
        field.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (radio) {
          var own = (radio.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) { return id && id !== errorId; });
          if (withError) own.push(errorId);
          if (own.length) radio.setAttribute('aria-describedby', own.join(' '));
          else radio.removeAttribute('aria-describedby');
        });
      }
    }

    function setError(field, message) {
      var error = field.querySelector('[data-error]');
      error.textContent = message;
      error.hidden = !message;
      describe(field, Boolean(message));
      var flagged = isGroup(field) ? field : field.querySelector('input');
      if (message) flagged.setAttribute('aria-invalid', 'true');
      else flagged.removeAttribute('aria-invalid');
    }

    function validate() {
      var invalid = [];
      fields.forEach(function (field) { setError(field, ''); });

      fields.forEach(function (field) {
        if (field.hasAttribute('data-required') && active(field) && !value(field)) {
          invalid.push({ field: field, message: field.getAttribute('data-error-message') });
        }
      });

      if (pairMode) {
        var pairs = {};
        fields.forEach(function (field) {
          var name = field.getAttribute('data-pair');
          if (name) (pairs[name] = pairs[name] || []).push(field);
        });
        var names = Object.keys(pairs);
        var started = names.filter(function (name) {
          return pairs[name].some(function (field) { return value(field); });
        });
        if (started.length === 0) {
          names.forEach(function (name) {
            var first = pairs[name][0];
            invalid.push({ field: first, message: first.getAttribute('data-either-message') || first.getAttribute('data-error-message') });
          });
        } else {
          started.forEach(function (name) {
            pairs[name].forEach(function (field) {
              if (!value(field)) invalid.push({ field: field, message: field.getAttribute('data-error-message') });
            });
          });
        }
      }

      invalid.forEach(function (item) { setError(item.field, item.message); });
      invalid.sort(function (a, b) {
        return (a.field.compareDocumentPosition(b.field) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
      });
      return invalid.map(function (item) { return item.field; });
    }

    if (choice) choice.onSwitch(function () { fields.forEach(function (field) { if (!active(field)) setError(field, ''); }); });

    function clearOnInput(field) {
      var handler = function () { setError(field, ''); };
      field.addEventListener('change', handler);
      field.addEventListener('input', handler);
    }

    fields.forEach(function (field) {
      clearOnInput(field);
      if (field.getAttribute('data-opt-field') === 'radio') {
        field.addEventListener('change', function () {
          var name = field.querySelector('[data-selected-name]');
          if (name) name.textContent = value(field);
          if (pairMode) clearPair(field);
        });
      }
    });

    function clearPair(field) {
      var name = field.getAttribute('data-pair');
      if (!name) return;
      fields.forEach(function (other) {
        if (other !== field && other.getAttribute('data-pair')) setError(other, '');
      });
    }

    all(root, '.swatches').forEach(function (swatches) {
      var fieldset = swatches.closest('fieldset');
      var caption = fieldset && fieldset.querySelector('[data-swatch-caption]');
      if (!caption) return;
      function show(name) { caption.textContent = name || ''; }
      fieldset.addEventListener('focusin', function (event) {
        if (event.target.matches('input')) show(event.target.value);
      });
      fieldset.addEventListener('mouseover', function (event) {
        var label = event.target.closest('[data-swatch-name]');
        if (label) show(label.getAttribute('data-swatch-name'));
      });
      ['focusout', 'mouseout'].forEach(function (type) {
        fieldset.addEventListener(type, function () { show(''); });
      });
    });

    all(root, '.field__input--caps').forEach(function (input) {
      input.addEventListener('input', function () {
        var start = input.selectionStart;
        var end = input.selectionEnd;
        /* Leading spaces would use up the three-letter limit, so drop them as they are typed. */
        var lead = input.value.length - input.value.replace(/^\s+/, '').length;
        var upper = input.value.replace(/^\s+/, '').toUpperCase();
        if (upper !== input.value) {
          input.value = upper;
          input.setSelectionRange(Math.max(0, start - lead), Math.max(0, end - lead));
        }
      });
    });

    var opener = root.querySelector('[data-chart-open]');
    var dialog = root.querySelector('[data-chart-dialog]');
    if (opener && dialog && typeof dialog.showModal === 'function') {
      var note = opener.querySelector('[data-new-tab-note]');
      if (note) note.remove();
      opener.removeAttribute('target');
      opener.removeAttribute('rel');
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.addEventListener('click', function (event) {
        event.preventDefault();
        dialog.showModal();
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    return {
      validate: validate,
      focus: function (field) {
        var target = control(field);
        if (target) target.focus();
      }
    };
  }

  function initProduct(root) {
    if (ready.has(root)) return;
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var dataEl = root.querySelector('[data-product-data]');
    if (!form || !dataEl) return;
    ready.add(root);

    var data = JSON.parse(dataEl.textContent);
    var announce = announcer(root);
    var buy = initBuy(root, announce);
    var gallery = initGallery(root);
    initVariants(root, form, data, gallery, buy, announce);
    var fields = initFields(root);
    var pending = false;
    form.noValidate = true;

    function validateAll() {
      var message = buy.input ? buy.clamp() : '';
      var invalid = fields.validate();
      if (invalid.length) {
        fields.focus(invalid[0]);
        return false;
      }
      /* An icon set needs its exact number of designs. The picker shows the message and returns a card to focus. */
      var designTarget = window.mckDesignPicker && window.mckDesignPicker.check ? window.mckDesignPicker.check(root) : null;
      if (designTarget) {
        designTarget.focus();
        return false;
      }
      if (message) {
        buy.input.focus();
        return false;
      }
      return true;
    }

    function add() {
      var body = new FormData(form);
      Array.from(body.keys()).forEach(function (key) {
        if (!/^properties\[/.test(key)) return;
        var trimmed = String(body.get(key)).trim();
        if (trimmed === '') body.delete(key);
        else body.set(key, trimmed);
      });
      var errorEl = root.querySelector('[data-cart-error]');
      /* A design picker on the page builds the whole request (main line plus the extra-design line). */
      var plan = window.mckDesignPicker ? window.mckDesignPicker.prepare(root, body) : null;
      /* An optional additional design (Karlee) adds its own $ line to the same request. */
      if (window.mckKarlee && !(plan && plan.blocked)) plan = window.mckKarlee.augment(root, body, plan);
      if (plan && plan.blocked) {
        setText(errorEl, plan.message);
        return;
      }
      var addedEl = root.querySelector('[data-cart-added-text]');
      var addedBox = root.querySelector('[data-cart-added]');
      var viewCart = root.querySelector('[data-cart-link-added]');
      var label = buy.button.textContent;
      pending = true;
      buy.button.setAttribute('aria-disabled', 'true');
      buy.button.textContent = buy.button.getAttribute('data-label-adding');
      setText(errorEl, '');
      setText(addedEl, '');
      if (viewCart) viewCart.hidden = true;
      if (addedBox) addedBox.classList.remove('has-text');

      /* Only a rejected request (no response at all) falls back to the native post. A response that
         arrived but did not parse counts as received, so the item is never added twice. */
      var request = plan && plan.payload
        ? { method: 'POST', body: JSON.stringify(plan.payload), headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }
        : { method: 'POST', body: body, headers: { Accept: 'application/json' } };
      fetch(routesRoot() + 'cart/add.js', request)
        .then(function (response) {
          return response.json().then(
            function (json) { return { ok: response.ok, json: json }; },
            function () { return { ok: response.ok, json: {} }; }
          );
        }, function () { return null; })
        .then(function (result) {
          if (!result) {
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
          if (!result.ok || result.json.status) {
            var message = result.json.description || result.json.message;
            setText(errorEl, message || root.querySelector('[data-generic-error]').textContent);
            return;
          }
          setText(addedEl, root.querySelector('[data-added-message]').textContent);
          if (addedBox) addedBox.classList.add('has-text');
          if (viewCart) viewCart.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { added: true, item: result.json.items ? result.json.items[0] : result.json } }));
        })
        .catch(function () {})
        .then(function () {
          pending = false;
          buy.button.removeAttribute('aria-disabled');
          buy.button.textContent = label;
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (pending || !buy.button || buy.button.disabled) return;
      if (!validateAll()) return;
      if (!window.fetch || !window.FormData) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
      add();
    });
  }

  function initRecommendations(scope) {
    all(scope, '[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.getAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', 'true');
      fetch(url)
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
          if (next && next.innerHTML.trim()) el.innerHTML = next.innerHTML;
        })
        .catch(function () {});
    });
  }

  function initAll(scope) {
    all(scope, '[data-product-section]').forEach(initProduct);
    initRecommendations(scope);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  initAll(document);
})();
